import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { Content } from "core/layouts";
import { BaasicButton, BaasicModal } from "core/components";
import { FacilityOrderTemplateItemEdit } from "application/facility-order/components";
import { CreateFacilityOrderTemplateModal, EditFacilityOrderTemplateInactiveReasonModal, PatientInsuranceEditModal, PatientEditModal, OrderingDoctorEditModal } from "application/facility-order/components";
import { PatientScrollArrow } from "application/facility-order/components";
import { toDate, uuid } from "core/utils";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";

const FacilityOrderTemplateEditTemplate = function({facilityOrderTemplateEditViewStore}) {
   const { 
       facilityOrderTemplateStores, 
       contentLoading,
       btPatient,
       goToPatientPreview,
       brightreeBaseUrl,
       createFacilityOrderTemplateModal,
       openCreateFacilityOrderTemplateModal,
       isNewTemplate,
       reviewAll,
       nextPatient,
       previousPatient,
       goToNextPatient,
       goToPreviousPatient,
       goBackToPatientList,
       isImportEnabled,
       deleteNewTemplate,
       openPatientInsuranceEditModal,
       editFacilityOrderTemplateInactiveReasonModal,
       openEditFacilityOrderTemplateInactiveReasonModal,
       importFacilityOrder,
       patientInsuranceEditModal,
       initializeFacilityOrderTemplateList,
       patientEditModal,
       openPatientEditModal,
       orderingDoctorEditModal,
       openOrderingDoctorEditModal,
       openNewPatientPage,
       viewAllTemplates,
       showButtonViewAllTemplates,
       isPickTicketHeaderInProgres,
       isPickTicketHeaderCompleted
    } = facilityOrderTemplateEditViewStore;

    const handleDropDownItemsOnClick = (e) => {
        if (e.item.text === "New Template") {
            openCreateFacilityOrderTemplateModal()
        }
        if (e.item.text === "Edit Inactive Reason") {
            openEditFacilityOrderTemplateInactiveReasonModal()
        }
        if (e.item.text === "Import") {
            importFacilityOrder()
        }
        if (e.item.text === "New Patient") {
            openNewPatientPage()
        }
    }

    return (	
        <React.Fragment>
            <Content loading={contentLoading}>
            
            <div className={(isPickTicketHeaderInProgres || isPickTicketHeaderCompleted) ? "content__header-secondary u-position--stk--fix-top" : "content__header-secondary u-position--stk--fix-top u-padd--top--sml"}>
                {
                    (isPickTicketHeaderInProgres || isPickTicketHeaderCompleted) &&
                    <div style={{ lineHeight:"2", top: "0", left: "0", width: "100%",  backgroundColor: "rgba(255, 0, 0, 0.7)", marginLeft: "0px", marginRight: "0px"}} className="row u-mar--bottom--tny">
                        <spam style={{width: "100%", color: "white"}} className="type--center">{ isPickTicketHeaderInProgres ? "Purchasing is in progress. Don't make changes to the facility order." : "Purchasing is complete. Don't make changes to the facility order."} </spam>
                    </div>
                }
                <div className="row u-flex--even u-mar--x--lrg">  
                    <div className="col u-flex--center">
                        <BaasicButton
                            className="btn btn--icon"
                            icon="u-icon u-icon--med u-icon--btn-back"
                            label="Go Back"
                            onlyIcon={true}
                            onClick={async () => await goBackToPatientList()}
                        ></BaasicButton>
                    </div>     
                    <div className="col col-lrg-4 u-padd--left--none">
                        {btPatient && 
                            <div>
                                <h2 className="u-flex--primary">

                                    <a onClick={() => goToPatientPreview(btPatient)}>{btPatient.lastName}{btPatient.firstName && ', ' + btPatient.firstName}</a> {" "}
                                    <a className="u-flex--primary u-mar--left--tny u-mar--right--tny" target='_blank' href={`${brightreeBaseUrl}Patient/frmPatientPersonalRO.aspx?PatientKey=${btPatient.patientKey}&Edit=0`}>
                                        <i className="u-icon u-icon--med u-icon--persons"></i>
                                    </a>
                                    <BaasicButton
                                        className="btn btn--icon"
                                        label='Edit Patient Details'
                                        icon='u-icon u-icon--edit u-icon--med'
                                        onlyIcon={true}
                                        onClick={() => openPatientEditModal()}>
                                    </BaasicButton>
                                </h2>
                                <span className="u-mar--right--tny">Date of Birth: <strong>{toDate(btPatient.dateOfBirth)}</strong></span> | 
                                <span className="u-mar--x--tny">SSN: <strong>{btPatient.ssn}</strong></span> |
                                <span className="u-mar--x--tny">Height: <strong>{btPatient.height}</strong></span> | 
                                <span className="u-mar--left--tny">Weight: <strong>{btPatient.weight}</strong></span>
                            </div>
                        }
                    </div>
                    <div className="col col-lrg-5 u-padd--left--lrg">
                        {btPatient && 
                            <React.Fragment>
                                <p className="u-flex--primary">Ordering Doctor:<strong style={{margin:"5px"}}>{btPatient.orderingDoctor ? btPatient.orderingDoctor : " - "}</strong> <BaasicButton
                                    className="btn btn--icon"
                                    label='Edit Ordering Doctor'
                                    icon='u-icon u-icon--edit u-icon--sml'
                                    onlyIcon={true}
                                    onClick={() => openOrderingDoctorEditModal()}>
                                </BaasicButton></p> 
                                    <p className="u-flex--primary">
                                    {btPatient.activePrimaryPayor && 
                                    <React.Fragment key={uuid()}><span className={btPatient.activeSecondaryPayor ? "u-mar--x--tny" : "u-mar--right--tny"}>{"Primary"}: <strong>{btPatient.activePrimaryPayor.payorPolicyInfo.name}</strong></span>{btPatient.activeSecondaryPayor ? "|" : " "}</React.Fragment>}
                                    {btPatient.activeSecondaryPayor && 
                                    <React.Fragment key={uuid()}><span className={btPatient.activeSecondaryPayor ? "u-mar--x--tny" : "u-mar--right--tny"}>{"Secondary"}: <strong>{btPatient.activeSecondaryPayor.payorPolicyInfo.name}</strong></span></React.Fragment>}
                                    {!btPatient.activePrimaryPayor && !btPatient.activeSecondaryPayor &&
                                        <span className="u-mar--right--tny"><strong>No primary or secondary insurance.</strong></span>
                                    }
                                    <BaasicButton
                                        className="btn btn--icon"
                                        label='Edit Insurance'
                                        icon='u-icon u-icon--edit u-icon--sml'
                                        onlyIcon={true}
                                        onClick={() => openPatientInsuranceEditModal()}>
                                    </BaasicButton>
                                    </p> 
                            </React.Fragment>
                        }
                    </div>
                    <div className="col u-flex--justify-end-text-center u-padd--top--sml u-padd--right--none">
                        <BaasicButton
                            className="btn btn--base btn--primary u-mar--right--tny"
                            label="Review All"
                            onClick={() => reviewAll()}
                        >
                        </BaasicButton>
                        <DropDownButton
                            fillMode={"solid"}
                            themeColor={"primary"}
                            text="Actions"
                            onItemClick={(e) => handleDropDownItemsOnClick(e)}
                            buttonClass="btn btn--base btn--ghost"
                        >
                            <DropDownButtonItem text="New Template"/>
                            <DropDownButtonItem text="Edit Inactive Reason"/>
                            <DropDownButtonItem text="Import" disabled={!isImportEnabled}/>
                            <DropDownButtonItem text="New Patient"/>
                        </DropDownButton>
                        <div className="u-flex--even">
                            <PatientScrollArrow direction="left" disabled={previousPatient ? false : true} scrollPatient={goToPreviousPatient}/>
                            <PatientScrollArrow direction="right" disabled={nextPatient ? false : true} scrollPatient={goToNextPatient}/>
                        </div>
                    </div>
            </div>
        </div>	
        <div className="container u-padd--y--sml--no-inherit">
            <div className="content__main">
                    {facilityOrderTemplateStores != undefined && facilityOrderTemplateStores.length > 0 && facilityOrderTemplateStores.map(store => {
                        const newTemplateIndicator = isNewTemplate(store.item) ? { borderLeft: "3px solid rgba(32, 76, 123, 0.7)"} : {};
                        return (
                            <div key={store.id} className="row">
                                <div className="col col-sml-12 col-lrg-12">
                                    <div className="card card--primary u-mar--x--lrg u-mar--bottom--sml" style={newTemplateIndicator}>
                                        <FacilityOrderTemplateItemEdit
                                         facilityOrderTemplateItemEditViewStore={store}
                                         brightreeBaseUrl={brightreeBaseUrl}
                                         deleteNewTemplate={deleteNewTemplate}
                                         refreshTemplates={initializeFacilityOrderTemplateList}
                                         />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    { showButtonViewAllTemplates &&
                        <div className="nav--primary__collapse u-mar--top--tny">
                            <BaasicButton
                                className="btn btn--base btn--ghost"
                                label="View all templates"
                                onClick={() => viewAllTemplates()}
                            >
                            </BaasicButton>
                        </div>
                    }
            </div>
            
            <BaasicModal modalParams={createFacilityOrderTemplateModal} className="modal__content modal--sml">
                <CreateFacilityOrderTemplateModal/>
            </BaasicModal>
            <BaasicModal modalParams={editFacilityOrderTemplateInactiveReasonModal}>
                <EditFacilityOrderTemplateInactiveReasonModal />
            </BaasicModal>
            <BaasicModal modalParams={patientInsuranceEditModal} className="modal__content modal--med">
                <PatientInsuranceEditModal />
            </BaasicModal>
            <BaasicModal modalParams={patientEditModal}>
                <PatientEditModal />
            </BaasicModal>
            <BaasicModal modalParams={orderingDoctorEditModal} className="modal__content modal--med">
                <OrderingDoctorEditModal />
            </BaasicModal>
        </div>
        </Content>
    </React.Fragment>
    );
};

FacilityOrderTemplateEditTemplate.propTypes = {
    facilityOrderTemplateEditViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderTemplateEditTemplate);